import React from "react";

var progress = {
  "Advanced":           100,
  "Intermediate Upper": 80,
  "Intermediate":       66,
  "Basic":              33,
};

var levelDisplay = {
  "Advanced":           { label: "Expert",     tagClass: "tag is-success",  barClass: "progress is-success" },
  "Intermediate Upper": { label: "Proficient", tagClass: "tag is-info",     barClass: "progress is-info"    },
  "Intermediate":       { label: "Familiar",   tagClass: "tag is-warning",  barClass: "progress is-warning" },
  "Basic":              { label: "Beginner",   tagClass: "tag is-light",    barClass: "progress"            },
};

var skillIcons = {
  // DevOps
  "Cloud(AWS, Azure, GCP)":       "fas fa-cloud-upload-alt",
  "Jenkins & CI/CD":              "fas fa-infinity",
  "Scripting(Py/Shell)":          "fas fa-terminal",
  "Kubernetes & Docker":          "fab fa-docker",
  "Ansible":                      "fas fa-server",
  "ArgoCD":                       "fas fa-code-branch",
  "Terraform":                    "fas fa-layer-group",
  "Influx(TICK Stack)":           "fas fa-chart-line",
  "ELK Stack":                    "fas fa-search",
  // Software Developer
  "Object Oriented Programming":  "fas fa-cubes",
  "Design Patterns":              "fas fa-drafting-compass",
  "Java":                         "fab fa-java",
  "Python":                       "fab fa-python",
  "Hibernate":                    "fas fa-file-code",
  "Spring5 / Spring Boot":        "fas fa-leaf",
  "ReactJS":                     "fab fa-react",
  "MySQL, Postgres":               "fas fa-database",
  "MongoDB, Cassandra":            "fas fa-stream",
};

function ProgressBar(props) {
  const icon = skillIcons[props.text];
  const level = levelDisplay[props.level] || { label: props.level, tagClass: "tag is-light", barClass: "progress" };
  return (
    <div>
      <span className="title is-5 is-spaced">
        {icon && <i className={icon + " fa-fw"} style={{ marginRight: "0.45rem", color: "#3273dc" }}></i>}
        {props.text}
      </span>
      <span className="skill-percentage">
        <span className={level.tagClass}>{level.label}</span>
      </span>
      <progress
        className={level.barClass}
        value={progress[props.level]}
        max="100">
        {progress[props.level]}%
      </progress>
    </div>
  );
}

export default ProgressBar;
